<template>    
    <b-row class="justify-content-md-center" > 
        <b-col cols="8">     
            <h1>Add Coin</h1>
            <hr>   
            <b-input-group prepend="Name">    
                <b-form-input v-model='asset.name'>Name:</b-form-input>
            </b-input-group>
            <br>
            <b-input-group prepend="Symbol">      
                <b-form-input v-model='asset.symbol'>Symbol:</b-form-input>
            </b-input-group>
            <br>
            <b-input-group prepend="Exchange">  
                <b-form-input v-model='asset.exchange'>Exchange:</b-form-input>
            </b-input-group>
            <br>
            <b-input-group prepend="Resolve">   
                <b-form-input v-model='asset.resolveTo'>Resolve To (base):</b-form-input>
            </b-input-group>
            <br>
            <b-input-group prepend="Link">  
                <b-form-input v-model='asset.link'>Link:</b-form-input>
            </b-input-group>
            <br>    
            <b-input-group prepend="Note">
                <b-form-input v-model='asset.note'></b-form-input>
            </b-input-group>
            <br>
            <b-btn class='text-center' @click='pushCoin'>Add Coin</b-btn>
        </b-col>  
        <b-col cols='12'>
            <br>
            <b-table striped hover outlined :fields="coinFields" :items="coinList">  </b-table>  
        </b-col>         
    </b-row>  
</template>
<script>

import * as firebase from 'firebase'
export default {
  name: 'app',
  data () {
    return {
      update: false,
      coinFields: ['name', 'symbol', 'exchange', 'resolveTo', 'link', 'note'],
      coinList: [],
      asset: {
        name: '',
        symbol: '',
        exchange: 'Binance',
        resolveTo: 'BTC',
        note: 'None',
        link: 'None'
      }
    }
  },
  methods: {
    pushCoin () {
      this.saveData('assets', this.asset)
    },
    saveData (root, payload) { // save the user assets is good
      console.log('saving data', root, payload)
      firebase.database()
        .ref('/' + root + '/')
        .push(payload)
        .then((data) => {
          console.log('Returned:', data)
        // ugly reset form data
          this.asset.name = ''
          this.asset.symbol = ''
          this.asset.exchange = 'Binance'
          this.asset.resolveTo = 'BTC'
          this.asset.link = 'None'
          this.asset.note = 'None'
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  created () {
    var database = firebase.database()

    database.ref('assets')
    .on('child_added', data => {
    //   let obj = data.val()
      console.log('child Added', data.val())
      this.coinList.push(data.val())
    })
  }
}
</script>

console.log('Getting Assets List')
      firebase.database().ref('assets')
      .once('value')
      .then((data) => {
        console.log('back from the Database', data.val)
        // this.assetsList = data.val()
        const obj = data.val()
        const assets = []
        for (let key in obj) {
          assets.push({
            id: key,
            name: obj[key].name,
            symbol: obj[key].symbol,
            exchange: obj[key].exchange,
            resolveTo: obj[key].resolveTo,
            link: obj[key].link,
            note: obj[key].note,
            added: obj[key].added
          })
        }
        this.assetsList = assets
      })
      .catch((error) => {
        console.log(error)
      })


// WEBPACK FOOTER //
// src/components/splash/btr-addcoin.vue